<template>
	<div class="max-w-full lg:max-w-3xl mx-auto px-12 lg:px-0">
		<div class="text-2xl font-light text-gray-800">
	    Please provide your contact details below.
	  </div>

		<div class="mt-6 relative">
			<div class="absolute text-sm text-gray-800 bg-gray-300" 
				style="margin:2px;padding:9px 10px;">
				First name
			</div>
			<input type="text" class="input-standard pl-24" v-model="lead.firstName" ref="firstName" />
		</div>

		<div class="mt-2 text-red-500 text-base" v-if="firstNameError != null">
    	{{ firstNameError }}
    </div>

		<div class="mt-4 relative">
			<div class="absolute text-sm text-gray-800 bg-gray-300" 
				style="margin:2px;padding:9px 12px;">
				Last name
			</div>
			<input type="text" class="input-standard pl-24" v-model="lead.lastName" />
		</div>

		<div class="mt-2 text-red-500 text-base" v-if="lastNameError != null">
    	{{ lastNameError }}
    </div>

		<div class="mt-4 relative">
			<div class="absolute text-sm text-gray-800 bg-gray-300" 
				style="margin:2px;padding:9px 21px;">
				Mobile
			</div>
			<input type="text" class="input-standard pl-24" v-model="lead.mobile" v-on:keyup="mobileChanged" />
		</div>

		<div class="mt-2 text-red-500 text-base" v-if="mobileError != null">
    	{{ mobileError }}
    </div>

		<div class="mt-4 relative">
			<div class="absolute text-sm text-gray-800 bg-gray-300" 
				style="margin:2px;padding:9px 26px;">
				Email
			</div>
			<input type="text" class="input-standard pl-24" v-model="lead.email" />
		</div>

		<div class="mt-2 text-red-500 text-base" v-if="emailError != null">
    	{{ emailError }}
    </div>

	  <div class="mt-8">
	  	<a href="#" @click.prevent="next"
	  		:class="{ 
	  			'text-white py-4 rounded text-sm uppercase font-semibold inline-block px-16 overflow-hidden' : true, 
	  			'bg-blue-500 hover:bg-blue-600' : canGoNext(), 
	  			'bg-gray-500 hover:bg-gray-600' : !canGoNext() }">
	  		<div class="float-left">Next</div>

        <svg width="22" height="22" stroke-width="2" class="ml-4 float-left" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#chevron-right"/>
        </svg>
	  	</a>
	  </div>

	  <div class="mt-4 ml-2">
	  	<a href="#" @click.prevent="back()"
	  		class="text-gray-500 hover:underline">Go back</a>
	  </div>

	</div>
</template>

<script>
  import validator from 'validator'

  export default {

    mounted() {
    	this.$refs.firstName.focus()
    },

    data() {
      return {
				lead: null,
				
				firstNameError: null,
				lastNameError : null,
				mobileError   : null,
				emailError    : null
      }
    },

    created() {
    	if(this.$route.params.data != null) {
    		this.lead = JSON.parse(decodeURIComponent(this.$route.params.data))
    	} else {
    		this.lead = {}
    	}
    },

  	methods : {
  		canGoNext() {
  			return this.lead.firstName != null && this.lead.lastName != null && this.lead.mobile != null && this.lead.email != null && this.lead.email.length > 0 && validator.isEmail(this.lead.email)
  		},

  		mobileChanged() {
  			this.lead.mobile = this.formatPhoneNumber(this.lead.mobile)
  		},

  		back() {
  			this.$router.push({
					name  : 'client-lead-capture-primary-reason',
					params: {
  					data : encodeURIComponent(JSON.stringify(this.lead))
  				}
  			})
  		},

  		next() {
  			let valid = true

				this.firstNameError = null
				this.lastNameError  = null
				this.mobileError    = null
				this.emailError     = null
  			
        if(this.lead.firstName == null || this.lead.firstName.length == 0) {
          this.firstNameError = "Please type a valid first name."
          valid = false
        }

        if(this.lead.lastName == null || this.lead.lastName.length == 0) {
          this.lastNameError = "Please type a valid last name."
          valid = false
        }

        if(this.lead.mobile == null || this.lead.mobile.length == 0) {
          this.mobileError = "Please type a valid mobile phone number."
          valid = false
        }

        if(this.lead.email == null || !validator.isEmail(this.lead.email)) {
          this.emailError = "Please type a valid email."
          valid = false
        }

        if(valid) {
					this.$router.push({
						name  : 'client-lead-capture-loan-amount',
						params: {
	  					data : encodeURIComponent(JSON.stringify(this.lead))
	  				}
	  			})
	  		}
  		}
  	}
  }
</script>